import PublishedLegalPage from "./PublishedLegalPage"
import { LEGAL } from "../../config/legal"

// /terms-and-conditions: the User Agreement governs use of the site and the app; one published text (RB-326)
const TermsAndConditions = () => (
    <PublishedLegalPage title="User Agreement" url={LEGAL.termsUrl} version={LEGAL.agreementVersion} />
)

export default TermsAndConditions
